<div class="modal inmodal fade in create-modal" [ngClass]="{'show': showModal}">
    <form #form="ngForm" (ngSubmit)="onSubmit(form)" submittable autocomplete="off">
        <div class="modal-dialog ">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="row">
                        <h4 class="modal-title col-sm-8">Create {{title}}</h4>
                        <div class="input-group-btn pull-right">
                            <button tabindex="-1" class="btn btn-primary submit"
                                    type="submit" [disabled]="disabledSubmit">Save</button>
                            <button data-toggle="dropdown" class="btn btn-primary dropdown-toggle" type="button"
                                    aria-expanded="false"><span class="caret"></span></button>
                            <ul class="dropdown-menu pull-right">
                                <li><a (click)="closeModal()">Cancel</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="modal-body">
                    <!--  ** Building **  -->
                    <div class="row m-b-xs" [hidden]="inDirectoryItemView || directoryService.buildingsForUpdate.length < 2">
                        <div class="dv-label col-sm-4 strong">Building</div>
                        <div class="dv-value-edit col-sm-8">
                            <select class="form-control" [ngModel]="buildingId" name="building" required #buildingSelect
                                    (change)="changeBuilding($event.target.value)">
                                <option value="" hidden></option>
                                <option *ngFor="let build of directoryService.buildingsForUpdate" [value]="build.id">
                                    {{build.name}}
                                </option>
                            </select>
                        </div>
                    </div>

                    <!--  ** Unit **  -->
                    <div class="row m-b-xs" [hidden]="inDirectoryItemView">
                        <div class="dv-label col-sm-4 strong">Unit</div>
                        <div class="dv-value-edit col-sm-8">
                            <search-select [ngModel]="suiteId" name="suite" required #suiteSelect
                                           (ngModelChange)="getResidentsBySuiteId($event)"
                                           [data]="suiteToSearchSelect(suites)"></search-select>
                            <spinner [spinnerShow]="buildingSelect.value && !suites.length"></spinner>
                        </div>
                    </div>

                    <!--** Car owner ** -->
                    <div class="row m-b-xs">
                        <div class="dv-label col-sm-4 strong">Car owner</div>
                        <div class="dv-value-edit col-sm-8">
                            <select class="form-control" name="ownerId" ngModel [disabled]="!residents.length">
                                <option value="" hidden></option>
                                <option *ngFor="let resident of residents" [value]="resident.id">{{resident.fullName}}
                                </option>
                            </select>
                            <spinner [spinnerShow]="suiteSelect.value && !residents.length"></spinner>
                        </div>

                        <div *ngIf="form.value.ownerId === '0'" class="dv-value-edit col-sm-8 col-sm-offset-4">
                            <input class="form-control" type="text" name="customOwnerName" [ngModel]=""
                                   placeholder="Car Owner">
                        </div>
                    </div>

                    <!--** LICENSE PLATE ** -->
                    <div class="row m-b-xs m-t-md">
                        <div class="dv-label col-sm-4 strong">License Plate #</div>
                        <div class="dv-value-edit col-sm-8">
                            <input class="form-control" name="licensePlate" ngModel required maxlength="255">
                        </div>
                    </div>

                    <!--** BRAND ** -->
                    <div class="row m-b-xs">
                        <div class="dv-label col-sm-4 strong">Make</div>
                        <div class="dv-value-edit col-sm-8">
                            <input class="form-control" name="brand" ngModel maxlength="255">
                        </div>
                    </div>

                    <!--** MODEL ** -->
                    <div class="row m-b-xs">
                        <div class="dv-label col-sm-4 strong">Model</div>
                        <div class="dv-value-edit col-sm-8">
                            <input class="form-control" name="model" ngModel maxlength="255">
                        </div>
                    </div>

                    <!--** YEAR ** -->
                    <div class="row m-b-xs">
                        <div class="dv-label col-sm-4 strong">Year</div>
                        <div class="dv-value-edit col-sm-8">
                            <input class="form-control" name="year" ngModel maxlength="255">
                        </div>
                    </div>

                    <!--** COLOR ** -->
                    <div class="row m-b-xs">
                        <div class="dv-label col-sm-4 strong">Color</div>
                        <div class="dv-value-edit col-sm-8">
                            <input class="form-control" name="color" ngModel maxlength="255">
                        </div>
                    </div>

                    <!--** NOTE ** -->
                    <div class="row m-b-xs">
                        <div class="dv-label col-sm-4 strong">Notes</div>
                        <div class="dv-value col-sm-8">
                            <textarea class="form-control" name="note" ngModel maxlength="255"></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <div class="modal-backdrop fade in" (click)="onClose(form)"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/directory/create-modal/vehicle-create/vehicle-create.component.html